import { IntlShape } from 'react-intl'

import { create, enforce, omitWhen, test } from 'vest'
import { BuyAndWindEffectKeys, type BuyAndWinEffect } from '../../../../typings'
import { suite as benefitValidation } from './Benefit/validation'
import { messages } from './messages'
import { suite as triggerValidation } from './Trigger/validation'

export function triggerSuite(intl: IntlShape, name: string) {
  const { $t } = intl

  return create((trigger: BuyAndWinEffect[BuyAndWindEffectKeys.TRIGGER]) => {
    test(name, $t(messages.validation.triggerEmpty), () => {
      enforce(trigger).isNotUndefined()
    })

    omitWhen(!trigger, () => {
      test(name, $t(messages.validation.generic), () => {
        enforce(
          triggerValidation(intl)(trigger!).isValidByGroup(
            BuyAndWindEffectKeys.TRIGGER
          )
        ).isTruthy()
      })
    })
  })
}

export function benefitSuite(intl: IntlShape, name: string) {
  const { $t } = intl

  return create((benefit: BuyAndWinEffect[BuyAndWindEffectKeys.BENEFIT]) => {
    test(name, $t(messages.validation.benefitEmpty), () => {
      enforce(benefit).isNotUndefined()
    })

    omitWhen(!benefit, () => {
      test(name, $t(messages.validation.generic), () => {
        enforce(
          benefitValidation(intl)(benefit!).isValidByGroup(
            BuyAndWindEffectKeys.BENEFIT
          )
        ).isTruthy()
      })
    })
  })
}
